
const {mk} = require('../utils/misc');
const {addToObject} = require('../utils/pubSub');

function SudokuCell(el, x, y, value) {
    this.el = el;
    this.div = mk('div', el);
    this.x = x;
    this.y = y;
    this.name = `${x}-${y}`;
    this.value = value;
    this.wrap = mk('label', this.div);
    if (x % 3 === 2) {
        this.el.className = 'edge';
    }
    this.input = mk('input', this.wrap);
    this.input.className = 'cell';
    this.input.type = 'text';
    this.input.maxLength = 1;
    this.value = value || null;

    this.input.addEventListener('input', (e) => {
        this.onInput(e);
        this.input.select();
    });
    this.input.addEventListener('focus', (e) => {
        this.input.select();
        this.emit('focus', e);
    });
    this.input.addEventListener('blur', (e) => {
        this.emit('blur', e);
    });
    this.input.addEventListener('click', (e) => {
        this.input.select();
    });
    this.input.addEventListener('keyup', (e) => {
        this.input.select();
    });

    for (let i = 1; i < 10; i++) {
        const note = mk('span', this.div);
        note.innerText = i + '';
        note.className = this.mkNoteClassName(i, true);
    }

    addToObject(this);

    this.notes = {};
}

Object.assign(SudokuCell.prototype, {
    isACell: true,
    valid: true,
    highlight: false,
    focus: false,
    noteClassName: 'note',
    noteNumberClassBase: 'note-',
});

SudokuCell.prototype.toString = function () {
    return `Cell[${this.x},${this.y}](${this.value || ''})`;
};

SudokuCell.prototype.mkNoteClassName = function (number, hidden) {
    return `${this.noteClassName} ${this.getNoteNumberClassName(number)}${hidden ? ' hidden' : ''}`;
};

SudokuCell.prototype.getNoteNumberClassName = function (number) {
    return `${this.noteNumberClassBase}${number}`;
};

SudokuCell.prototype.clearNotes = function () {
    for (let i = 1; i < 10; i++) {
        this.removeNote(i);
    }
    this.notesPresent = false;
};

SudokuCell.prototype.removeNote = function (number) {
    this.notes[number] = false;
    const note = this.el.querySelector('.' + this.getNoteNumberClassName(number));
    note.className = this.mkNoteClassName(number, true);
    this.notesPresent = false;
    for (let i = 1; i < 10; i++) {
        this.notesPresent = this.notesPresent || this.notes[number]
    }
};

SudokuCell.prototype.addNote = function (number) {
    if (this.notes[number]) return;
    this.notes[number] = true;
    const note = this.el.querySelector('.' + this.getNoteNumberClassName(number));
    note.className = this.mkNoteClassName(number, false);
    this.notesPresent = true;
};

SudokuCell.prototype.reset = function () {
    this.input.value = '';
    this.notes = {};
    this.setValue(null);
    this.clearNotes();
};

SudokuCell.prototype.setValue = function (value, updateInput) {
    const change = this.value !== value;
    this.value = value;
    if (change) {
        this.emit('change', value);
    }
    if (value) {
        this.clearNotes();
    }
    if (updateInput) {
        this.input.value = value;
    }
};

SudokuCell.prototype.getValidity = function () {
    return this.valid;
};

SudokuCell.prototype.setValidity = function (valid) {
    this.valid = valid;
    this.updateClassName();
};

SudokuCell.prototype.setHighlight = function (highlight) {
    this.highlight = !!highlight;
    this.updateClassName();
};

SudokuCell.prototype.setFocus = function (focus) {
    this.focus = !!focus;
    this.updateClassName();
};

SudokuCell.prototype.updateClassName = function () {
    this.wrap.className = [
        this.valid ? 'valid' : 'invalid',
        this.highlight ? 'highlight' : '',
        this.focus ? 'focus' : ''
    ].join(' ');
};

SudokuCell.prototype.getValue = function () {
    return this.value;
};

SudokuCell.prototype.onInput = function (event) {
    if (event.data === null) {
        this.setValue(null);
        return;
    }
    let num = parseInt(event.data, 10);
    if (isNaN(num) || num < 1 || num > 9) {
        this.input.value = this.value;
        event.preventDefault();
        return false;
    }
    this.setValue(num);
};

const CellSet = function () {
    [].slice.call(arguments).forEach(arg => {
        if (!arg) {
            return;
        }
        if (arg.isCellSet || Array.isArray(arg)) {
            arg.forEach(cell => {
                this.add(cell);
            });
            return;
        }
        if (arg.isACell) {
            this.add(arg);
            return;
        }
        this.name = arg + '';
    });
    this.cellNames = {};
};

CellSet.prototype = [];
CellSet.prototype.isCellSet = true;


CellSet.prototype.toString = function () {
    if (this.name) {
        return `${this.name}-${[].toString.call(this)}`;
    } else {
        return [].toString.call(this);
    }
};

CellSet.prototype.push = function (el) {
    console.warn('You shouldn\'t be using push on a CellSet');
    [].push.call(this, el);
};

CellSet.prototype.add = function (cell) {
    if (!cell.isACell) return;
    if (this.cellNames[cell.name]) return;
    this.cellNames[cell.name] = true;
    [].push.call(this, cell);
};

CellSet.prototype.addAll = function (cells) {
    (cells || []).forEach(cell => this.add(cell));
};

CellSet.prototype.contains = function (cell) {
    return !!this.cellNames[cell.name];
};

SudokuCell.Set = CellSet;

module.exports = SudokuCell;

